"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./style.less");

var _strings = require("../../utils/strings");

var _antd = require("antd");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DEFAULT_RENDER_OPTION = function DEFAULT_RENDER_OPTION(_ref) {
  var name = _ref.name,
      slug = _ref.slug;
  return name;
};

var CustomGroupedSelect = function CustomGroupedSelect(_ref2) {
  var title = _ref2.title,
      options = _ref2.options,
      _ref2$selected = _ref2.selected,
      selected = _ref2$selected === void 0 ? false : _ref2$selected,
      onSelect = _ref2.onSelect,
      className = _ref2.className,
      _ref2$renderOption = _ref2.renderOption,
      renderOption = _ref2$renderOption === void 0 ? DEFAULT_RENDER_OPTION : _ref2$renderOption,
      _ref2$showSearch = _ref2.showSearch,
      showSearch = _ref2$showSearch === void 0 ? true : _ref2$showSearch,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$childrenField = _ref2.childrenField,
      childrenField = _ref2$childrenField === void 0 ? 'children' : _ref2$childrenField;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      selectOpen = _useState2[0],
      setSelectOpen = _useState2[1];

  var filterOption = (0, _react.useMemo)(function () {
    if (!showSearch) {
      return undefined;
    }

    return function (searchTerm, option) {
      return (0, _strings.makeSearchString)(option.title || '').includes((0, _strings.makeSearchString)(searchTerm));
    };
  }, [showSearch]);
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "CustomGroupedSelect ".concat(className || '')
  }, /*#__PURE__*/_react.default.createElement(_antd.Select, {
    size: "large",
    disabled: disabled,
    className: "CustomGroupedSelect-button ".concat(selectOpen ? 'CustomGroupedSelect-open' : 'CustomGroupedSelect-closed', " ").concat(disabled ? 'CustomGroupedSelect-disabled' : ''),
    dropdownClassName: "CustomGroupedSelect-menu",
    value: selected || undefined,
    onSelect: onSelect,
    open: selectOpen,
    onDropdownVisibleChange: setSelectOpen,
    showSearch: showSearch,
    filterOption: filterOption,
    placeholder: title,
    defaultValue: null
  }, options.map(function (_ref3) {
    var slug = _ref3.slug,
        name = _ref3.name,
        rest = _objectWithoutProperties(_ref3, ["slug", "name"]);

    var children = rest[childrenField] || [];
    return /*#__PURE__*/_react.default.createElement(_antd.Select.OptGroup, {
      key: slug,
      label: name
    }, (children || []).map(function (_ref4) {
      var slug = _ref4.slug,
          name = _ref4.name,
          rest = _objectWithoutProperties(_ref4, ["slug", "name"]);

      return /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
        key: slug,
        value: slug,
        title: name || slug,
        className: "CustomGroupedSelect-option"
      }, renderOption(_objectSpread({
        name: name,
        slug: slug
      }, rest)));
    }));
  })));
};

var _default = CustomGroupedSelect;
exports.default = _default;